import { FlussDefinition } from "modules/fluss/types/fluss";

export type CallActivityTargetReason = "missing_key" | "missing_pinned_version" | "pinned_unavailable" | "active_unavailable";

export type CallActivityTargetResult =
    | { status: "resolved"; id: string }
    | { status: "unresolved"; reason: CallActivityTargetReason };

export interface CallActivityTargetBinding {
    definitionKey?: unknown;
    definition_key?: unknown;
    versionPolicy?: unknown;
    version_policy?: unknown;
    pinnedVersion?: unknown;
    pinned_version?: unknown;
}

const value = (...candidates: unknown[]) => candidates.find((candidate) => candidate !== undefined && candidate !== null && candidate !== "");

// Mirrors Fluss::MetadataResolver#call_activity_target (metadata_resolver.rb:194) and ADR-03.
export const resolveCallActivityDefinitionId = (
    definitions: FlussDefinition[],
    binding: CallActivityTargetBinding | null | undefined,
): CallActivityTargetResult => {
    const definitionKey = String(value(binding?.definitionKey, binding?.definition_key) || "").trim();
    if (!definitionKey) return { status: "unresolved", reason: "missing_key" };

    const versionPolicy = String(value(binding?.versionPolicy, binding?.version_policy) || "active");
    if (versionPolicy === "pinned") {
        const pinnedVersion = Number(value(binding?.pinnedVersion, binding?.pinned_version));
        if (!pinnedVersion) return { status: "unresolved", reason: "missing_pinned_version" };

        const match = definitions.find((definition) =>
            definition.definition_key === definitionKey &&
            definition.status === "published" &&
            definition.disabled !== true &&
            definition.version === pinnedVersion
        );
        return match ? { status: "resolved", id: match.id } : { status: "unresolved", reason: "pinned_unavailable" };
    }

    const match = definitions.find((definition) =>
        definition.definition_key === definitionKey &&
        definition.is_active === true &&
        definition.disabled !== true
    );
    return match ? { status: "resolved", id: match.id } : { status: "unresolved", reason: "active_unavailable" };
};
